export default String.raw``